import React, { forwardRef } from 'react'

import './textarea.scss'

// export const Textarea = forwardRef(({ register, label, error, ...props }, ref) => {
export const Textarea = ({ register, label, error, ...props }) => {
  const wrapperClass = [
    'form-item',
    'form-item-textarea'
  ]

  if (error) {
    wrapperClass.push('error')
  }

  return (
    <div className={wrapperClass.join(' ')}>
      {label && (
        <label className="mb-2">
          {label}
        </label>
      )}
      <textarea {...props} {...register} />
      {error && error.message && (
        <span className="validation">
          {error.message}
        </span>
      )}
    </div>
  )
}

/*export const Textarea = ({ register, label, error, ...props }) => {
  const wrapperClass = [
    'form-item',
    'form-item-textarea'
  ]

  if (error) {
    wrapperClass.push('error')
  }

  return (
    <div className={wrapperClass.join(' ')}>
      {label && (
        <label>{label}</label>
      )}
      <textarea ref={{...register}} />
      {error && error.message && (
        <span className="validation">
          {error.message}
        </span>
      )}
    </div>
  )
}*/

export default Textarea